import Utils from './Utils'
const DEBUG = Utils.getQueryStringParam('pomad') || localStorage.getItem('rt_debug') === '1';
export default DEBUG;
